import { dbParameterGetCached } from '@devicebits/parameter-store'

export const env = {
  stage: import.meta.env.VITE_REACT_APP_STAGE,
  project: import.meta.env.VITE_REACT_APP_PROJECT,
  flavor: import.meta.env.VITE_REACT_APP_FLAVOR || 'default'
}

const paramApiConfig = {
  token: import.meta.env.VITE_REACT_APP_DB_PARAM_API_TOKEN,
  url: import.meta.env.VITE_REACT_APP_DB_PARAM_API_URL
}

export const getParam = dbParameterGetCached(paramApiConfig)(env)
